import React from 'react'
import CustomLink from 'components/shared/CustomLink'

interface ButtonShellProps {
  isAnchor?: boolean
  to: string
  target?: string
  rel?: string
  children: any
  className?: string
}

function ButtonShell({
  isAnchor = false,
  to,
  target,
  rel,
  children,
  className = '',
}: ButtonShellProps) {
  if (!isAnchor) {
    return (
      <CustomLink to={to} className={className} target={target} rel={rel}>
        {children}
      </CustomLink>
    )
  }
  return (
    <a href={to} className={className} target={target} rel={rel}>
      {children}
    </a>
  )
}

export default ButtonShell
